<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../utils/UIStore';
import { reformatDate } from '../utils/dateUtils';
let version = '';
let notes = [];
let date = '';
//load current state from uistore
uiStore.releaseStore.subscribe((store) => {
  version = store.currentVersion;
  notes = store.currentNotes;
  date = store.currentReleaseDate;
});
let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});
</script>

<div class="pop_up_bg">
  <div class="pop_up_window">
    <div class="pop_up_content">
      <div class="p_popup">
        <p>{uiTexts.releaseNotesPopup.welcome} <b>{reformatDate(date)}</b> {@html uiTexts.releaseNotesPopup.newVersionPublished}</p>
        <p style="text-align:left; margin-top: 20px; border-top:1px solid rgba(0, 0, 0, .5);">{@html uiTexts.releaseNotesPopup.mainChanges}</p>
        <ul style=" margin-bottom: 20px; border-bottom:1px solid rgba(0, 0, 0, .5);" class="bullet-list">
          {#each notes as note}
            <li>
              {note}
            </li>
          {/each}
        </ul>

        <p style="padding-bottom:10px;" class="textlink">
          {uiTexts.releaseNotesPopup.moreNotesInFaq}
          <a href="/faq">{uiTexts.releaseNotesPopup.faqLinkText}</a>.

        </p>
        <div class="row center" style="gap:20px">
          <slot name="agree" />
        </div>
      </div>
    </div>
  </div>
</div>

<style>
    p {
    font-size: 1rem;
  }
  ul {
    padding-top: 10px;
    text-align: left;
  }

  li {
    font-size: 1rem;
    padding-left: 0px;
    padding: 5px 0 5px 0;
  }
  ul.bullet-list {
    margin: 0;
    padding: 10px 0 0 12px;
  }
  ul.bullet-list li {
    list-style: circle;
    margin-bottom: 8px;
    padding: 0;
  }
</style>
